<template>
  <section-page title="Permissions">
    <form-field-select
      label="Is Owner"
      v-model="form.is_owner"
      :validation-errors="validationErrors.is_owner"
    >
      <option :value="1">Yes</option>
      <option :value="0">No</option>
    </form-field-select>

    <template v-if="!form.is_owner">
      <form-field-checkbox
        label="Can Access All Leads"
        v-model="form.can_access_all_leads"
        :validation-errors="validationErrors.can_access_all_leads"
        require-prefix
        secondary-label="Will allow the User to see all Lead, even ones the User is not Assigned to"
      ></form-field-checkbox>

      <form-field-checkbox
        label="Can Delete Leads"
        v-model="form.can_delete_leads"
        :validation-errors="validationErrors.can_delete_leads"
        require-prefix
        secondary-label="Will allow the User to delete individual leads"
      ></form-field-checkbox>

      <form-field-checkbox
        label="Can Export Leads"
        v-model="form.can_export_leads"
        :validation-errors="validationErrors.can_export_leads"
        require-prefix
        secondary-label="Will allow the User to export leads via settings"
      ></form-field-checkbox>

      <form-field-checkbox
        label="Can Access All Tasks"
        v-model="form.can_access_all_task"
        :validation-errors="validationErrors.can_access_all_task"
        require-prefix
        secondary-label="Will allow the User to see all Tasks, even ones the User is not Assigned to"
      ></form-field-checkbox>

      <form-field-checkbox
        label="Can Access All Appointments"
        v-model="form.can_access_all_appointments"
        :validation-errors="validationErrors.can_access_all_appointments"
        require-prefix
        secondary-label="Will allow the User to see all Appointments, even ones the User is not going to"
      ></form-field-checkbox>

      <form-field-checkbox
        label="Can Access Comm Logs Page"
        v-model="form.can_access_comm_log_page"
        :validation-errors="validationErrors.can_access_comm_log_page"
        require-prefix
        secondary-label="Allows Access to Comms Log page. Comms will still be accessible via Lead Modal"
      ></form-field-checkbox>

      <form-field-checkbox
        label="Can Export Contacts"
        v-model="form.can_export_contacts"
        :validation-errors="validationErrors.can_export_contacts"
        require-prefix
        secondary-label="Will allow the User to export contacts"
      ></form-field-checkbox>

      <form-field-checkbox
        label="Can Access Settings"
        v-model="form.can_access_settings"
        :validation-errors="validationErrors.can_access_settings"
        require-prefix
        secondary-label="Will allow the Setting section of the app"
      ></form-field-checkbox>

      <form-field-checkbox
        label="Can Access Financial Stats"
        v-model="form.can_access_financial_stats"
        :validation-errors="validationErrors.can_access_financial_stats"
        require-prefix
        secondary-label="Allows Access to the Funnel Page, and Kpis for Projected Profit, and Actual Profit"
      ></form-field-checkbox>

      <form-field-checkbox
        label="Can Edit Financial Information"
        v-model="form.can_edit_financials"
        :validation-errors="validationErrors.can_edit_financials"
        require-prefix
        secondary-label="Allows Access to the Buying Info, Selling Info, and Buying Offers on the record Modal"
      ></form-field-checkbox>

      <form-field-checkbox
        label="Can Access Billing Information"
        v-model="form.can_manage_account"
        :validation-errors="validationErrors.can_manage_account"
        require-prefix
        secondary-label="Allows Access to Account Billing Section"
      ></form-field-checkbox>

      <form-field-checkbox
        label="Can Access User Permissions"
        v-model="form.can_manage_users"
        :validation-errors="validationErrors.can_manage_users"
        require-prefix
        secondary-label="Allows Access to User Management Section"
      ></form-field-checkbox>
    </template>

    <div class="flex flex-end mt-150">
      <button-default
        :loading="isSaving"
        @click="update"
      >
        Update
      </button-default>
    </div>
  </section-page>
</template>

<script>
import api from "../../../api";

export default {
  name: "UserPermissions",
  props: {
    user: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      isSaving: false,
      validationErrors: {},
      form: {
        is_owner: this.user.is_owner,
        can_access_all_leads: this.user.can_access_all_leads,
        can_delete_leads: this.user.can_delete_leads,
        can_export_leads: this.user.can_export_leads,
        can_access_all_task: this.user.can_access_all_task,
        can_access_all_appointments: this.user.can_access_all_appointments,
        can_access_settings: this.user.can_access_settings,
        can_access_financial_stats: this.user.can_access_financial_stats,
        can_edit_financials: this.user.can_edit_financials,
        can_manage_account: this.user.can_manage_account,
        can_manage_users: this.user.can_manage_users,
        can_access_comm_log_page: this.user.can_access_comm_log_page,
        can_export_contacts: this.user.can_export_contacts,
      },
    }
  },
  methods: {
    update() {
      this.isSaving = true
      api.users.updatePermissions(this.user.id, this.form)
        .then(res => {
          this.$buefy.toast.open({
            message: "Permissions was updated",
            type: "is-success"
          });
        })
        .catch(error => {
          if (error.response.status === 422) {
            this.validationErrors = error.response.data.errors;
          }
        })
        .finally(() => this.isSaving = false)
    },
  },
}
</script>

<style scoped lang="scss">

</style>
